import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import { projectsData } from "../data/projectsData";

const categories = ["all", "freelance", "professional", "personal"];

export default function Projects() {
  const { t, localize } = useLanguage();
  const [params, setParams] = useSearchParams();
  const selected = categories.includes(params.get("category")) ? params.get("category") : "all";
  const projects = localize(projectsData).filter((project) => selected === "all" || project.category === selected);

  useEffect(() => {
    document.querySelector('meta[name="keywords"]')?.setAttribute("content", "Hessah Alhamadi, projects, full-stack developer, Kuwait, Rails, React, Next.js, OutSystems");
  }, []);

  function filter(category) {
    const next = new URLSearchParams(params);
    if (category === "all") next.delete("category");
    else next.set("category", category);
    setParams(next, { replace: true });
  }

  return (
    <main id="projects" className="projects project-gallery-page">
      <div className="projects-heading">
        <div><p className="projects-eyebrow">{t("projects.gallery.eyebrow")}</p><h1>{t("projects.gallery.heading")}</h1></div>
        <p className="projects-introduction">{t("projects.gallery.introduction")}</p>
      </div>
      <div className="project-filters" role="group" aria-label={t("projects.filters.label")}>
        {categories.map((category) => <button type="button" key={category} aria-pressed={selected === category} onClick={() => filter(category)}>{t(`projects.filters.${category}`)}</button>)}
      </div>
      <p className="project-filter-description" role="status">{t(`projects.filters.${selected}Description`)}</p>
      <div className="project-gallery">
        {projects.map((project) => (
          <article className="project-tile" key={project.id}>
            <Link className="project-tile-image" to={`/projects/${project.id}`} state={{ projectsSearch: params.toString() }} aria-label={`${t("projects.details.view")} ${project.title}`}>
              <img src={project.cardImage.src} alt={project.cardImage.alt} loading="lazy" />
            </Link>
            <div className="project-tile-body">
              <p className="project-category">{t(`projects.filters.${project.category}`)}</p>
              <h2>{project.title}</h2>
              <p className="project-summary">{project.summary || project.description}</p>
              <ul className="project-tech-preview" aria-label={t("projects.technologies")}>
                {project.technologies.slice(0, 3).map((tech) => <li key={tech.iconName} dir="ltr">{tech.iconName}</li>)}
              </ul>
              <Link className="project-text-link" to={`/projects/${project.id}`} state={{ projectsSearch: params.toString() }}>{t("projects.details.view")} <span aria-hidden="true">↗</span></Link>
            </div>
          </article>
        ))}
      </div>
    </main>
  );
}
